import React, { useState } from 'react';

export default function UpcomingAnniversariesWidget({ anniversaries = { work: [], marriage: [] } }) {
  const [activeTab, setActiveTab] = useState('work'); // 'work' | 'marriage'

  const currentList = activeTab === 'work' ? (anniversaries?.work || []) : (anniversaries?.marriage || []);

  const getInitials = (name) => {
    if (!name) return 'EM';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  };

  return (
    <div className="flex flex-col rounded-3xl border border-outline-variant/25 bg-surface p-6 shadow-xs">
      {/* Header and Tab switcher */}
      <div className="flex items-center justify-between border-b border-outline-variant/15 pb-4">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-500/10 text-amber-600">
            <span className="material-symbols-outlined text-xl">military_tech</span>
          </div>
          <div>
            <h3 className="text-sm font-bold text-on-surface">Anniversaries</h3>
            <p className="text-[11px] text-slate-500">Milestones & service tenures</p>
          </div>
        </div>

        {/* Tab Switcher */}
        <div className="flex rounded-xl bg-surface-container-high p-1 text-xs font-bold">
          <button
            type="button"
            onClick={() => setActiveTab('work')}
            className={`rounded-lg px-2.5 py-1 transition cursor-pointer ${
              activeTab === 'work'
                ? 'bg-surface text-on-surface shadow-xs'
                : 'text-slate-600 hover:text-on-surface'
            }`}
          >
            Work ({anniversaries?.work?.length || 0})
          </button>
          <button
            type="button"
            onClick={() => setActiveTab('marriage')}
            className={`rounded-lg px-2.5 py-1 transition cursor-pointer ${
              activeTab === 'marriage'
                ? 'bg-surface text-on-surface shadow-xs'
                : 'text-slate-600 hover:text-on-surface'
            }`}
          >
            Marriage ({anniversaries?.marriage?.length || 0})
          </button>
        </div>
      </div>

      <div className="mt-4 flex-1 space-y-2.5 overflow-y-auto max-h-[320px] pr-1">
        {currentList.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <span className="material-symbols-outlined text-3xl text-slate-300">workspace_premium</span>
            <p className="mt-2 text-xs font-semibold text-slate-500">
              No upcoming {activeTab} anniversaries
            </p>
            <span className="text-[11px] text-slate-400">Milestone records will appear here!</span>
          </div>
        ) : (
          currentList.map((item, idx) => (
            <div
              key={item.id || item.AcHeadID || idx}
              className="flex items-center justify-between rounded-2xl border border-outline-variant/20 bg-surface-container-lowest p-3 transition hover:bg-surface-container-low"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-amber-500/20 to-indigo-500/20 text-amber-700 font-extrabold text-xs">
                  {item.profile_photo_path ? (
                    <img
                      src={item.profile_photo_path}
                      alt={item.Name}
                      className="h-full w-full rounded-xl object-cover"
                    />
                  ) : (
                    <span>{getInitials(item.Name)}</span>
                  )}
                </div>

                <div className="min-w-0">
                  <h4 className="text-xs font-bold text-on-surface truncate">{item.Name}</h4>
                  <div className="flex items-center gap-1.5 text-[11px] text-slate-500">
                    <span>{item.department || 'General'}</span>
                    <span>•</span>
                    <span className="font-mono">{item.Anniversary || item.Anniversary1}</span>
                  </div>
                </div>
              </div>

              <div className="shrink-0 flex items-center gap-2">
                <span className="rounded-full bg-amber-500/10 text-amber-800 border border-amber-500/20 px-2.5 py-0.5 text-[10px] font-bold">
                  {item.yearsCompleted ? `${item.yearsCompleted} Yr${item.yearsCompleted > 1 ? 's' : ''}` : 'Milestone'}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
